<template>
  <div class="card-body py-3">
    <h3 class="mb-0 t-500">
      Therapeutics/diagnostics
      <editable v-if="isLoaded && canEdit && !isEmpty(therapeutics)"
        :isActive="isEditMode"
        :text="addOrEditText(therapeutics.length)"
        @create="handleEdit()"
        @cancel="handleEdit()">
      </editable>

      <i v-if="isLoaded && (isEmpty(therapeutics) || !canEdit)" class="fa fa-star d-block pull-right t-placeholder"></i>
    </h3>

    <!-- render content when is loaded -->
    <template v-if="isLoaded">
      <!-- no discipline present and can edit-->
      <p v-if="isEmpty(therapeutics) && !isEditMode && canEdit" class="mb-0 mt-4 text-center">
        <i class="fa fa-plus d-block t-secondary"></i>
        <a href="#" @click.prevent="handleEdit()" class="t-sm">Add your therapeutics/diagnostics</a>
      </p>

      <!--  no discipline present and cannot edit -->
      <p v-if="isEmpty(therapeutics) && !canEdit" class="mb-0 mt-1 t-sm t-secondary">
        No therapeutic/diagnostic added.
      </p>

      <!-- render research types -->
      <ul v-if="!isEmpty(therapeutics) && !isEditMode" class="list-unstyled mb-0 mt-3">
        <li class="badge badge-pill badge-secondary--white bd-radius pull-left mr-2 mb-2 word-overflow" v-for="(therapeutic, index) in therapeutics" :key="index">
          <span>{{ therapeutic.name }}</span>
        </li>
      </ul>

      <!-- add multi select -->
      <multi-select v-if="isTherapeuticLoaded && isEditMode && canEdit"
        v-model="therapeuticValues"
        :options="therapeuticOptions"
        label="name"
        track-by="id"
        :multiple="true"
        placeholder="Your therapeutics/diagnostics"
        class="mt-3"
        @input="updateTherapeutic">
      </multi-select>
    </template>

    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import Editable from '@/components/shared/Editable'
import MultiSelect from 'vue-multiselect'

import TherapeuticService from '@/services/therapeutic'
import ResearcherService from '@/services/researcher'

export default {
  name: 'researcherTherapeutic',
  components: {
    Spinner,
    Editable,
    MultiSelect
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    researcher: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isEditMode: false,
      error: null,
      isTherapeuticLoaded: false,
      therapeuticValues: [],
      therapeuticOptions: []
    }
  },
  computed: {
    therapeutics () {
      return this.researcher.therapeutics
    }
  },
  mounted () {
    if (this.isLoaded) this.fetch()
  },
  watch: {
    isLoaded (newVal, oldVal) {
      if (newVal !== oldVal && newVal) this.fetch()
    }
  },
  methods: {
    fetch () {
      this.canEdit && this.isEmpty(this.therapeutics)
        ? this.isEditMode = true
        : this.isEditMode = false

      TherapeuticService.get().then(therapeutics => {
        this.therapeuticOptions = therapeutics
        this.therapeuticValues = this.therapeutics
        this.isTherapeuticLoaded = true
      }).catch(err => {
        this.error = this.handleError(err)
        this.isTherapeuticLoaded = !this.isEmpty(this.error)
      })
    },
    handleEdit () {
      this.isEditMode = !this.isEditMode
    },
    updateTherapeutic (values, id) {
      let ids = []
      for (let v of values) ids.push(v.id)

      ResearcherService.updateTherapeutic(this.$currentUser.slug_values[0], { ids: ids }).then(therapeutics => {
        this.$events.$emit('researcher:updated', 'therapeutics', therapeutics)
        this.isEditMode = true
      }).catch(err => {
        this.error = this.handleError(err)
        this.isEditMode = !this.isEmpty(this.error)
      })
    }
  }
}
</script>
